// extracted by mini-css-extract-plugin
export default {"tableInfo":"total-table_tableInfo__MI9qc","skeleton":"total-table_skeleton__Ithhx","shimmer":"total-table_shimmer__Hmj23"};